import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Tag from 'src/store/models/Tag';
import TimeInput from 'components/Pickers/TimeInput';
import { BUDGET_TYPE as _BUDGET_TYPE } from 'src/boot/constants';
export default {
  components: {
    TimeInput: TimeInput
  },
  props: {
    props: {
      type: Object,
      required: true
    },
    project: {
      type: Object
    },
    tag: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    selectable: {
      type: Boolean,
      default: true
    },
    selection: {
      type: Boolean,
      default: false
    },
    canBeArchived: {
      type: Boolean,
      default: false
    },
    canBeDeleted: {
      type: Boolean,
      default: false
    },
    newTag: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localTag: _objectSpread({}, this.tag),
      editing: !this.tag.tag_id,
      loading: false
    };
  },
  computed: {
    BUDGET_TYPE: function BUDGET_TYPE() {
      return _BUDGET_TYPE;
    },
    tagList: function tagList() {
      return this.props.row;
    }
  },
  methods: {
    undoChanges: function undoChanges() {
      // reset localTag to original
      this.localTag = _objectSpread({}, this.tag);
      this.editing = false;
    },
    saveTag: function saveTag() {
      var _this = this;

      if (this.loading) return;

      if (this.tag.tag_id) {
        this.loading = true;
        Tag.api().update(this.tag.tag_id, this.localTag).then(function (result) {
          _this.editing = false;

          _this.$emit('update-tag', result.response.data);

          _this.$q.notify({
            type: 'positive',
            message: _this.$t('components.tagManagement.updated_last_tag')
          });
        }).catch(function () {}).finally(function () {
          _this.loading = false;
        });
      } else {
        if (this.tagList.projects_count) {
          this.openDialog('UserConfirmationDialog', {
            type: 'warning',
            title: this.$t('components.tagManagement.add_tag_to_linked_projects'),
            message: this.$t('components.tagManagement.tag_list_already_linked', {
              el: this.tagList.projects_count
            }),
            cancelButtonText: this.$t('components.tagManagement.create_without_adding'),
            confirmButtonText: this.$t('components.tagManagement.add_tag_to_projects'),
            html: true,
            confirmTimeout: 0,
            onConfirm: function onConfirm() {
              _this.createTag(true);
            },
            onCancel: function onCancel() {
              _this.createTag(false);
            }
          });
        } else {
          this.createTag();
        }
      }
    },
    createTag: function createTag() {
      var _this2 = this;

      var linkToProjects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.loading = true;
      return Tag.api().store(_objectSpread(_objectSpread({}, this.localTag), {}, {
        tag_list_id: this.tagList.tag_list_id,
        link_to_projects: linkToProjects
      })).then(function (result) {
        _this2.editing = false;

        _this2.$emit('update-tag', _objectSpread(_objectSpread({}, result.response.data), {}, {
          selected: true
        }));

        _this2.$q.notify({
          type: 'positive',
          message: _this2.$t('components.tagManagement.created_last_tag')
        });
      }).catch(function () {}).finally(function () {
        _this2.loading = false;
      });
    },
    archiveTag: function archiveTag() {
      var _this3 = this;

      if (this.loading) return;
      this.loading = true;
      Tag.api().archive(this.tag.tag_id).then(function (result) {
        _this3.$emit('update-tag', result.response.data);

        _this3.$q.notify({
          type: 'positive',
          message: _this3.$t('components.tagManagement.archived_last_tag')
        });
      }).catch(function () {}).finally(function () {
        _this3.loading = false;
      });
    },
    unarchiveTag: function unarchiveTag() {
      var _this4 = this;

      if (this.loading) return;
      this.loading = true;
      Tag.api().unarchive(this.tag.tag_id).then(function (result) {
        _this4.$emit('update-tag', result.response.data);

        _this4.$q.notify({
          type: 'positive',
          message: _this4.$t('components.tagManagement.unarchived_last_tag')
        });
      }).catch(function () {}).finally(function () {
        _this4.loading = false;
      });
    },
    deleteTag: function deleteTag() {
      var _this5 = this;

      if (this.loading) return;
      this.openDialog('UserConfirmationDialog', {
        type: 'warning',
        icon: 'fal:cog',
        title: this.$t('components.tagManagement.delete_confirmation_tag'),
        message: this.$t('components.tagManagement.tag_confirmation_delete'),
        onConfirm: function onConfirm() {
          _this5.loading = true;
          return Tag.api().destroy(_this5.tag.tag_id).then(function (result) {
            _this5.$emit('remove-tag');

            _this5.$q.notify({
              type: 'positive',
              message: _this5.$t('components.tagManagement.delete_tag')
            });
          }).catch(function () {}).finally(function () {
            _this5.loading = false;
          });
        }
      });
    }
  }
};